module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "gwi-profile"
    }
  }, [_c('scroll', {
    staticClass: "voucher-qr-code",
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('section', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn-ok",
    attrs: {
      "id": "profile-btn-addVoucher",
      "type": "button",
      "disabled": 3 === _vm.voucherList.length
    },
    on: {
      "click": _vm.goAddVoucher
    }
  }, [_vm._v("办卡/绑卡")]), _vm._v(" "), _c('p', {
    staticClass: "f-minor text-center mytips"
  }, [(3 === _vm.voucherList.length) ? _c('span', {
    attrs: {
      "id": "profile-span-full"
    }
  }, [_vm._v("就诊凭证已满，如需绑定请先解绑其他就诊凭证")]) : (0 === _vm.voucherList.length) ? _c('span', {
    attrs: {
      "id": "profile-span-empty"
    }
  }, [_vm._v("请先办理或绑定就诊凭证")]) : _c('span', {
    attrs: {
      "id": "profile-span-normal"
    }
  }, [_vm._v("还能绑定"), _c('span', {
    staticClass: "mygray",
    attrs: {
      "id": "profile-span-surplus"
    }
  }, [_vm._v(_vm._s(3 - _vm.voucherList.length))]), _vm._v("张就诊凭证")])])]), _vm._v(" "), _vm._l((_vm.voucherList), function(voucher, index) {
    return _c('voucher-item', {
      key: index,
      staticClass: "voucher-list",
      class: (0 === index) ? 'selected' : '',
      attrs: {
        "id": 'profile-voucherItem-' + voucher.cardNo,
        "voucher": voucher,
        "edit": 0,
        "is-frequent": index === 0
      },
      on: {
        "selected": function($event) {
          return _vm.selectVoucher(voucher, index, $event)
        }
      }
    })
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a396f95","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/voucher/VoucherQrCode.vue
// module id = 795
// module chunks = 0